export enum ProductType{
    PRODUCT = 'Producto',
    SERVICE = 'Servicio'
}